
import XLSX from "xlsx";
import jsPDF from 'jspdf';
import moment from 'moment';
class PrinterHelper {
  public print<T>(type: printer.type, title: string, titleModule: string, groupProperties: Array<printer.group>) {
    switch (type) {
      case "pdf":
        this.printSchedaPdf(title, titleModule, groupProperties)
        break;
      case "excel":
        this.printSchedaExcel(title, groupProperties, titleModule)
        break;
    }
  }

  private printSchedaPdf(title: string, titleModule: string, groupProperties: Array<printer.group>) {
    let pdf = init(title + ' (' + titleModule + ')')

    groupProperties.forEach(groupProp => {
      checkIfAddPage(pdf, 90);
      addGroupingTitle(pdf, groupProp.header);

      const properties = groupProp.data;
      for (const propKey of Object.keys(properties)) {
        let propVal = properties[propKey];
        if(propVal!=null) {
        checkIfAddPage(pdf);
        addLabel(pdf, propKey);
       
        if (Array.isArray(propVal)) {
          propVal.forEach((elem) => {
            checkIfAddPage(pdf);
            const value = typeof (elem) === "string" ? elem : `${Object.keys(elem).filter(k => (elem[k] || '') !== '').map((k) => `${k}: ${elem[k]}`).join(", ")}`;
            pdf = addValue(pdf, value);
          });
        } else{
          pdf = addValue(pdf, propVal.toString())
        }
      }
      }
    });
    pdf.doc.save(title);

    function checkIfAddPage(pdf, remainingSpace: number = 30) {
      if (pdf.top > (297 - remainingSpace)) {
        pdf.doc.addPage();
        var img = new Image()
        img.src = 'img/icons/favicon-196.png'
        pdf.doc.addImage(img, 'png', 190, 3, 14, 14)
        pdf.top = 30;
      }
    }

    function init(title: string) {
      var doc = new jsPDF("p", "mm", "a4");

      var img = new Image()
      img.src = 'img/icons/favicon-196.png'
      doc.addImage(img, 'png', 190, 3, 14, 14)


      doc.setFontStyle("bold")
      doc.setTextColor(48, 96, 96)
      doc.setFontSize(20);
      doc.text(title, 20, 25, null, null);

      doc.setFontStyle("normal");
      return { doc: doc, top: 30 };
    }

    function addGroupingTitle(pdf: any, text: string) {
      pdf.top += 8
      pdf.doc.setFontStyle("bold")
      pdf.doc.setTextColor(48, 96, 96);
      pdf.doc.setFontSize(16);
      pdf.doc.text(20, pdf.top, text);
      pdf.top += 3

      pdf.doc.setDrawColor(48, 96, 96)
      pdf.doc.setLineWidth(0.2)

      pdf.doc.line(20, pdf.top, 190, pdf.top)
      pdf.top +=2
      return pdf;
    }

    function addLabel(pdf: any, text: string) {
      pdf.top += 2
      pdf.doc.setFontStyle("normal")
      pdf.doc.setTextColor(48, 96, 96);
      pdf.doc.setFontSize(11);
      pdf.doc.text(20, pdf.top, text);
      pdf.top += 6
      return pdf;
    }

    function addValue(pdf: any, text: string) {
      pdf.doc.setTextColor(46, 49, 49);
      pdf.doc.setFontSize(9);
      var splitText = pdf.doc.splitTextToSize(text, 160);
      var dim = pdf.doc.getTextDimensions(splitText);
      pdf.doc.text(20, pdf.top, splitText);
      // pdf.doc.text(20, pdf.top, text);
      pdf.top += 2+dim.h
      return pdf;
    }
  }

  // private printSchedaExcel(title: string, titleModule: string, groupProperties: Array<printer.group>) {
    // var ws_data = [];
    // for (const k of keys)
    // {
    //   if (Array.isArray(object[k]))
    //   {
    //     object[k].forEach(e => { 
    //       let subKey = Object.keys(e)
    //       let substring = '';
    //       for (const k of subKey) {
    //         substring += k +': ' + e[k] + ', ';

    //       }
    //       ws_data.push([k,substring]); 
    //     });
    //   } else
    //   {
    //     ws_data.push([k, object[k]]);
    //   }
    // }

    // // ws_data.push(['Rilevatore', userInfo.firstName + ' ' + userInfo.lastName])

    // const wb = XLSX.utils.book_new();
    // wb.Props = {
    //   Title: title,
    //   CreatedDate: new Date()
    // }

    // let date = moment(new Date())
    // wb.SheetNames.push("umbrafloor");
    // wb.Sheets["umbrafloor"] = XLSX.utils.aoa_to_sheet(ws_data);
    // XLSX.writeFile(wb, `${title}_${date.format("YYYYMMDD-HHmm")}.xlsx`);
  // }
  // giuseppe new
  public printSchedaExcel(title: string, datas: Array<any>, sheetName: string, heading: string[] = null) {
    console.log(datas);
  //   const wb = XLSX.utils.book_new();
  //   wb.Props = {
  //     Title: title,
  //     CreatedDate: new Date()
  //   }

  //   if (!sheetName) {
  //     sheetName = title;
  //   }

  //   let date = moment(new Date())
  //   wb.SheetNames.push(sheetName);
  //   if (heading && heading.length > 0) {
  //     var ws = XLSX.utils.aoa_to_sheet([heading]);
  //     XLSX.utils.sheet_add_json(ws, datas, { header: heading, origin: { r: 1, c: -(heading.length) }, skipHeader: true });
  //   }
  //   else {
  //     var ws = XLSX.utils.json_to_sheet(datas);
  //   }
  //   wb.Sheets[sheetName] = ws;
  //   XLSX.writeFile(wb, `${title.toLowerCase()}_${date.format("YYYYMMDDHHmm")}.xlsx`);
  // }

  // public printExcelByTables(title: string, datas: { tab: any, sheetName?: string }[]) {
  //   const wb = XLSX.utils.book_new();
  //   wb.Props = {
  //     Title: title,
  //     CreatedDate: new Date()
  //   }
  //   wb.SheetNames.push(title);

  //   for (var data of datas) {

  //     if (!data.sheetName) {
  //       data.sheetName = title;
  //     } else {
  //       wb.SheetNames.push(data.sheetName);
  //     }

  //     wb.Sheets[data.sheetName] = XLSX.utils.table_to_sheet(data.tab);
  //   }

  //   let date = moment(new Date())
  //   XLSX.writeFile(wb, `${title}_${date.format("YYYYMMDD-HHmm")}.xlsx`);
  }

  public printExcel(title: string, datas: Array<any>, sheetName: string, heading: string[] = null) {
    const wb = XLSX.utils.book_new();
    wb.Props = {
      Title: title,
      CreatedDate: new Date()
    }

    if (!sheetName) {
      sheetName = title;
    }

    let date = moment(new Date())
    wb.SheetNames.push(sheetName);
    if (heading && heading.length > 0) {
      var ws = XLSX.utils.aoa_to_sheet([heading]);
      XLSX.utils.sheet_add_json(ws, datas, { header: heading, origin: { r: 1, c: -(heading.length) }, skipHeader: true });
    }
    else {
      var ws = XLSX.utils.json_to_sheet(datas);
    }
    wb.Sheets[sheetName] = ws;
    XLSX.writeFile(wb, `${title}_${date.format("YYYYMMDD-HHmm")}.xlsx`);
  }
}
export const printerHelper = new PrinterHelper();
